import React, { useState } from 'react';
import { Button, Typography, Box } from '@mui/material';
import CustomNavbar from '../components/Navbar/Navbar';
import Sidebar from '../components/Sidebar/Sidebar';
import { Routes, Route } from 'react-router-dom';
import RevisionHomepage from './RevisionHomepage/RevisionHomepage';

function RevisorDashboard({ onLogout, username }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderCard = (Component) => (
    <div className={`card p-3 shadow-sm ${sidebarOpen ? 'card-expanded' : 'card-collapsed'}`}>
      <Component />
    </div>
  );

  return (
    <div className="App d-flex">
      <div className="flex-grow-1">
        <CustomNavbar 
          onLogout={onLogout} 
          username={username}
        />
        <main className={`main-content p-3 ${sidebarOpen ? 'sidebar-open' : ''}`}>
          <Routes>
            <Route index element={renderCard(RevisionHomepage)} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default RevisorDashboard;